module.exports = __webpack_public_path__ + "img/lange_crub.a39c07f4.jpg";